import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

export const experienceOfferedSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    postSupplierSaveExperience: builder.mutation({
      query: (data) => ({
        url: "supplier-save-experience",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
  }),
});

export const { usePostSupplierSaveExperienceMutation } = experienceOfferedSlice;
